import React from 'react';
import { Link } from 'react-router-dom';

interface AuthPageShellProps {
  eyebrow: string;
  title: string;
  description: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  maxWidthClass?: string;
}

const AuthPageShell: React.FC<AuthPageShellProps> = ({
  eyebrow,
  title,
  description,
  children,
  footer,
  maxWidthClass = 'max-w-md',
}) => (
  <div
    className="relative min-h-screen overflow-x-hidden bg-[linear-gradient(180deg,#f0fdfa_0%,#f8fafc_40%,#ffffff_100%)] px-4 py-10 sm:px-6 sm:py-14"
    dir="rtl"
  >
    <div
      className="pointer-events-none absolute inset-x-0 top-0 h-64 bg-[radial-gradient(ellipse_at_top,rgba(20_184_166_/_0.28),transparent_65%)]"
      aria-hidden
    />

    <div className={`relative mx-auto w-full ${maxWidthClass}`}>
      <div className="mb-6 flex justify-center sm:mb-8">
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-2xl border-2 border-brand-100 bg-white px-3 py-2 shadow-sm transition hover:border-brand-300"
          aria-label="الصفحة الرئيسية"
        >
          <img
            src={`${process.env.PUBLIC_URL}/favicon.ico`}
            alt="المنصة"
            className="h-11 w-auto object-contain sm:h-12"
            width={140}
            height={48}
            decoding="async"
          />
        </Link>
      </div>

      <div className="rounded-2xl border-2 border-brand-100 bg-white p-6 shadow-sm sm:p-8 md:p-10">
        <div className="mb-6 sm:mb-8">
          <div className="mb-3 flex items-center gap-2.5">
            <span
              className="inline-block h-5 w-1 shrink-0 rounded-full bg-brand-500"
              aria-hidden
            />
            <p className="text-sm font-semibold text-slate-900">{eyebrow}</p>
          </div>
          <h1 className="text-[clamp(1.5rem,1.4vw+1rem,2.1rem)] font-extrabold leading-snug text-slate-900">
            {title}
          </h1>
          <p className="mt-2 text-sm leading-relaxed text-slate-600 sm:text-base">{description}</p>
        </div>

        {children}

        {footer && <div className="mt-8">{footer}</div>}
      </div>
    </div>
  </div>
);

export const authInputClass =
  'block w-full rounded-xl border-2 border-brand-100 bg-white px-4 py-3.5 text-sm text-slate-900 shadow-sm outline-none transition-colors placeholder:text-slate-400 focus:border-brand-500 focus:ring-2 focus:ring-brand-50';

export const authLabelClass = 'mb-1.5 block text-sm font-semibold text-slate-900';

export const authPrimaryButtonClass =
  'flex min-h-12 w-full items-center justify-center rounded-xl bg-brand-600 px-4 py-3.5 text-sm font-bold text-white shadow-md shadow-brand-700/20 transition hover:bg-brand-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-70';

export default AuthPageShell;
